import { Information } from '@components/Information';

export const ForAll = () => {
  return (
    <Information description="Lab managers, sales representatives and ordering providers will have access to this selection." />
  );
};
